<template>
  <page>
    <div>
      <v-card>
        <form>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card-text>
                  <div slot="header"><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12 md4 lg6>
                        <cal-picker
                          v-model="form.tranDateFrom"
                          :label="label.tranDateFrom"
                          :data-vv-as="label.tranDateFrom"
                          data-vv-name="form.tranDateFrom"
                          :error-messages="errors.collect('form.tranDateFrom')"
                          v-validate="'required|start_after_today'"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs12 md4 lg6>
                        <cal-picker
                          v-model="form.tranDateTo"
                          :label="label.tranDateTo"
                          :data-vv-as="label.tranDateTo"
                          data-vv-name="form.tranDateTo"
                          :error-messages="errors.collect('form.tranDateTo')"
                          v-validate="toDateValidation(form.tranDateFrom)"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.branch"
                          :label="label.branch"
                          :error-messages="errors.collect('form.branch')"
                          data-vv-name="form.branch"
                          :data-vv-as="label.branch"
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showBranchHelpList = true">mdi-magnify</v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card>
      <v-flex xs12>
              <v-checkbox
                      :label="label.pbPrtParam"
                      v-model="form.pbPrtParam"
                      :error-messages="errors.collect('pbPrtParam')"
                      data-vv-name="pbPrtParam"
                      :data-vv-as="label  .pbPrtParam"
                    />
                  </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-form>
        <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
          <v-icon left dark>mdi-file-export</v-icon>
          {{ label.export }}
        </v-btn>
        <v-btn-toggle dense mandatory v-model="form.format">
          <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
            <span>{{ format.label }}</span>
            <v-icon :color="format.color">{{ format.icon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-form>
    </div>

    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="showBranchHelpList = false" @doAssign="doAssign($event)"></multi-branch-help-list>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'

export default {
  data() {
    return {
      form: {
        tranDateFrom: null,
        tranDateTo: null,
        branch: 'All',
        pbPrtParam: true,
        format: undefined
      },
      label: {
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'Transaction Date To',
        branch: 'Branch(es)',
        format: 'Export Format',
        pbPrtParam: 'Print Run Time Parameters',
        export: 'Export to'
      },
      menu: {},
      supportedFormat: [],
      loading: false,
      showBranchHelpList: false
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initCoinsPrem
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.getPropStatList()
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportCoinsPrem
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    toDateValidation(tranDateFrom) {
      const result = 'required|from_to_date:' + tranDateFrom
      return result
    },
    doAssign(obj) {
      this.form.branch = obj.finalSelectedItems.toString()
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return 'Entry Date To must be equal or greater than Entry Date From'
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          return isAfter(tomorrow, startDate)
        } else return true
      }
    })
  },
  watch: {},
  mixins: [MessageMixin],
  components: {
    MultiBranchHelpList
  }
}
</script>
